import styled, { keyframes } from 'styled-components';

const slideIn = keyframes`
  from {
    max-height: 0px;
  }

  to {
    max-height: 1000px;
  }
`;

export const SlideIn = styled.div`
  animation-play-state: running;
  overflow: hidden;
  max-height: 1000px;
  animation: ${slideIn} 1s ease 0s 1 normal forwards;
`;

export default SlideIn;
